// src/components/CosmicGatewayUltraPlus.js
import React, { useEffect, useRef } from "react";
import "./CosmicUltra+.css";
import { playNotificationSound } from "../utils/notificationAudio";

export default function CosmicGatewayUltraPlus({ visible }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!visible) return;

    // 🔊 Son ultra synchronisé
    playNotificationSound("/sounds/gong-cosmique-eternua.wav", { volume: 1 });

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    let fractals = [];

    // 🌌 Fractales sacrées qui tournent autour du centre
    for (let i = 0; i < 100; i++) {
      fractals.push({
        x: canvas.width / 2,
        y: canvas.height / 2,
        angle: Math.random() * Math.PI * 2,
        radius: Math.random() * 20 + 30,
        speed: Math.random() * 0.05 + 0.015,
        alpha: 1,
        size: Math.random() * 4 + 2,
      });
    }

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      fractals.forEach((f) => {
        f.angle += f.speed;
        f.radius += 0.2;
        f.alpha -= 0.007;

        const fx = f.x + Math.cos(f.angle) * f.radius;
        const fy = f.y + Math.sin(f.angle) * f.radius;

        const grad = ctx.createRadialGradient(
          fx, fy, 0,
          fx, fy, f.size * 3
        );
        grad.addColorStop(0, `rgba(220, 245, 255, ${f.alpha})`);
        grad.addColorStop(0.4, `rgba(120, 200, 255, ${f.alpha})`);
        grad.addColorStop(1, "rgba(0,0,0,0)");

        ctx.fillStyle = grad;
        ctx.beginPath();
        ctx.arc(fx, fy, f.size, 0, Math.PI * 2);
        ctx.fill();
      });

      fractals = fractals.filter((f) => f.alpha > 0);

      if (fractals.length > 0) requestAnimationFrame(draw);
    };

    draw();
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="ultraplus-overlay">
      {/* Effet warp sur tout l’écran */}
      <div className="ultraplus-warp" />

      {/* Portail du Sanctuaire (3 couches) */}
      <div className="sanctuary-portal">
        <div className="portal-ring portal-ring--outer" />
        <div className="portal-ring portal-ring--inner" />
        <div className="portal-core" />
        <div className="portal-runes">
          <span>∞</span>
          <span>✧</span>
          <span>✦</span>
          <span>✺</span>
        </div>
      </div>

      {/* Canvas des fractales */}
      <canvas ref={canvasRef} className="ultraplus-canvas" />
    </div>
  );
}
